<script setup lang="ts">
import { cn } from '@/lib/utils'
import { type HTMLAttributes } from 'vue'

const props = defineProps<{
  label: string
  value: number | string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    :class="
      cn(
        'flex items-baseline gap-1 rounded border border-white/5 bg-white/5 px-2 py-0.5 text-xs text-white/60 backdrop-blur-[30px]',
        props.class
      )
    "
  >
    <span class="">{{ props.label }}</span>
    <span class="text-sm text-white">{{ props.value }}</span>
  </div>
</template>

<style scoped></style>
